import ax from '@utils/axios'
import { handleError } from '@utils/helpers'
import { triggerFileDownload } from '@utils/fileHelpers'

async function generateReportsCSV(queryParams, isSharedView = false) {
  // This is used for both admetrics and lead metrics
  this.showCSVLoadingIndicator = true

  try {
    // TODO: this should all be calling the generateCSV endpoint,
    // however, the lead-metrics endpoint was updated without updated the generateCSV
    // endpoint so we have fix that. For right now, just using the old endpoints
    // for lead metrics.
    const endpoint = (isSharedView ? 'ad-metrics/salesforce/data/csv' : queryParams.report_type === 'admetrics' ? 'ad-metrics/generate-csv' : 'lead-metrics')
    
    const response = await ax.get(`/v2/reports/${endpoint}`, {
      params: {
        ...queryParams,
        as_csv: true
      },
      responseType: 'blob'  // Indicate that the server will respond with a blob
    })

    // Convert the blob to text
    const reader = new FileReader()
    reader.readAsText(response.data)
    reader.onloadend = () => {
      const csvText = reader.result
      const date = new Date().toLocaleDateString('en-US').replace(/\//g, '-')
      triggerFileDownload({ filename: `relevize-reports-${date}.csv`, content: csvText, contentType: 'text/csv' })
    }
  }
  catch(error) {
    handleError(error)
  }
  finally {
    this.showCSVLoadingIndicator = false
  }
}

export default {
  generateReportsCSV,
}
